import type { PackageType } from "@/lib/revenuecat/config";
import type { ReactNode } from "react";

const STANDARD_STYLES: Record<PackageType, string> = {
  weekly: "border-white/10 bg-white/[0.045] text-[#FD954F]",
  monthly: "border-[#FD954F]/35 bg-[rgba(253,149,79,0.14)] text-[#FFD0AE]",
  annual: "border-[#FD954F] bg-[#FD954F] text-[#1C1C1E]",
};

const ZEN_STYLES: Record<PackageType, string> = {
  weekly: "border-stone-700 bg-stone-800 text-stone-200",
  monthly: "border-stone-500 bg-stone-700 text-stone-100",
  annual: "border-stone-200 bg-stone-200 text-stone-950",
};

export function PlanValueBanner({
  children,
  packageType,
  variant = "standard",
}: {
  children: ReactNode;
  packageType: PackageType;
  variant?: "standard" | "zen";
}) {
  const styles = variant === "zen" ? ZEN_STYLES[packageType] : STANDARD_STYLES[packageType];

  return (
    <p
      className={`flex min-h-11 items-center justify-center border-b px-5 py-3 text-center text-[11px] font-extrabold uppercase leading-none tracking-[0.16em] ${styles}`}
      data-plan-value-banner={packageType}
    >
      {children}
    </p>
  );
}
